import { setGlobalConfig } from '@makemydeal/dr-activities-tradein';
import { SERVICE_BFF } from './constants';
import { buildBffApiUrl } from './buildUrl';
import type { IConfigObj } from '@makemydeal/dr-common-utils';
import type { TradeInConfig } from '../types';
import { tradeInHistory } from '../store/tradeInHistory';

/**
 * Creates a configuration object for trade-in functionality
 * Used by both global config setup and middleware initialization
 */
export const createTradeInConfigObject = (config: TradeInConfig) => {
    const servicesBff = config.services?.bff || { host: '', protocol: '', base: '' };
    const staticImages = (config.staticImages || { host: '', protocol: '', base: '' }) as IConfigObj;

    return {
        services: {
            bff: servicesBff
        },
        utils: {
            buildApiUrlWithServiceEndpoint: ({ service = SERVICE_BFF, endPoint = 'init' }): string =>
                buildBffApiUrl({ service, endPoint }, servicesBff),
            getCurrentFlowName: () => '',
            getCurrentLocation: () => {
                const location = tradeInHistory.location;
                return location.pathname;
            }
        },
        offerActionCreators: {
            updatedShopper: (shopperInfo: any) => shopperInfo,
            updatedTradeIn: (tradeIn: any) => tradeIn
        },
        hostActions: {
            relayTradeInEvents: config.hostActions?.relayTradeInEvents || (() => undefined)
        },
        kbbTradeInApiKey: config.kbbTradeInApiKey || '',
        renderMenuProducts: () => null,
        staticImages
    };
};

export const applyTradeInGlobalConfig = (input: { config: TradeInConfig }) => {
    const cfg: TradeInConfig = input.config;
    setGlobalConfig(createTradeInConfigObject(cfg));
};

export const configureTradeIn = applyTradeInGlobalConfig;
